export default __webpack_public_path__ + "static/media/volume.8025822c.svg";